import PresortDemo from "../components/table/DataTable";
import { useEffect, useState, useTransition } from "react";
import { Sidebar } from "primereact/sidebar";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import "./page.css"
import { } from "../store/api/orderAPI";
import { orderColumn } from "../metadata/order";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { tarifColumns } from "../metadata/tarifColumns";
import { useActionsHook } from "../hooks/useActionsHook";
import { useCreateOrUpdateTarifMutation, useDeleteTarifMutation, useGetTarifQuery } from "../store/api/tarifApi";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { t } from "i18next";




function Tarif() {
	const { data, error, isLoading } = useGetTarifQuery();
	const [createOrUpdateTarif] = useCreateOrUpdateTarifMutation();
	const [deleteTarif] = useDeleteTarifMutation();
	const tarifColumnsTr = useTranslatedColumns(tarifColumns);
	const delTarif = (event, [row]) => {
		confirmPopup({
			target: event.currentTarget,
			message: 'Вы точно хотите удалить?',
			icon: 'pi pi-exclamation-triangle',
			defaultFocus: 'reject',
			accept: (e) => {
				deleteTarif(row.tarif_guid);

			}
		});
	};
	const actions = useActionsHook([
		{
			onClick: (e, ...params) => {
				delTarif(e, params)

			},
			icon: "pi pi-trash"
		}
	])
	const items = [

		{
			label: 'React Website',
			icon: 'pi pi-external-link',
			command: () => {
				// window.location.href = 'https://react.dev/';
			}
		}
	];

	const [formData, setFormData] = useState({

	});

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		setFormData(data)
		setVisibleLeft(state => {
			return {
				visible: bool,
				data: data
			}
		})
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}

	function toggleSidebar(bool, data) {
		setFormData(data)
		setVisibleLeft(state => {
			return {
				visible: bool,
				data: data
			}
		})
	}

	return (<>

		<PresortDemo
			isLoading={isLoading}
			data={data}
			column={tarifColumnsTr.filter(i => !i.hidden) ?? Object.keys(data.data[0])}
			toggleSidebar={toggleSidebar}
			deleteHandler={(row, field) => {
				console.log(row, field);
			}}
			actions={actions}
		/>
		<SpeedDial
			// model={items}
			radius={120}
			type="quarter-circle"
			onClick={() => {
				toggleSidebar(true, {});
			}}
			direction="up-left"
			style={{ right: 15, bottom: 15 }} />
		<Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
			{/* <div className="user-sidebar"> */}
			<div className="user-sidebar-edit">
				{
					tarifColumns.filter((i) => i.editor).map(el => {
						return (
							<div>
								<Editor {...el} onBlur={onBlur} data={formData} />
							</div>
						)
					})
				}
				<div></div>
				<MyButton label={t("save")} onClick={() => {
					createOrUpdateTarif(formData);

				}} />
			</div>

		</Sidebar>
	</>);
}

export default Tarif;